import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
  cfgDForm,
  cfgDFormItem,
  cfgDFormParagraph,
  cfgDFormVersion,
  currentCellmodel,
  enumValidValueItem
} from './form-builder-model';
import {FormBuilderService} from './form-builder.service';
import {FormBuilderOpenFormComponent} from '../form-builder-open-form/form-builder-open-form.component';

@Component({
    selector: 'app-form-builder',
    templateUrl: './form-builder.component.html',
    styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit {

    constructor(public dialog: MatDialog,
                private cdFef: ChangeDetectorRef,
                private fbservice: FormBuilderService
    ) {}

    selectedCell: cfgDFormItem | undefined;  // = {DFormItemId: '1', DFormParagraphId: '1', DFormItemName: 'Lable 1', DFormMasterItemId: '1', ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 0, ParagraphRow: 1, ParagraphColumn: 1, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true};
    currentCell: currentCellmodel = {row: 0, col: 0};
    selectedForm: cfgDForm ;
    selectedVersion: cfgDFormVersion ;





    formCategories_enumValidValueItem: enumValidValueItem[] = [
        {ValidValueItemId: '1', ItemDisplayValue: 'Category 1', ItemOrder: 1},
        {ValidValueItemId: '2', ItemDisplayValue: 'Category 2', ItemOrder: 2},
        {ValidValueItemId: '3', ItemDisplayValue: 'Category 3', ItemOrder: 3},
        {ValidValueItemId: '4', ItemDisplayValue: 'Category 4', ItemOrder: 4}

    ];
    formDatSource_enumValidValueItem: enumValidValueItem[] = [
        {ValidValueItemId: '1', ItemDisplayValue: 'Generic', ItemOrder: 1},
        {ValidValueItemId: '2', ItemDisplayValue: 'Custom', ItemOrder: 2}


    ];
    formStatus_enumValidValueItem: enumValidValueItem[] = [
        {ValidValueItemId: '1', ItemDisplayValue: 'Draft', ItemOrder: 1},
        {ValidValueItemId: '2', ItemDisplayValue: 'Ready To Review', ItemOrder: 2},
        {ValidValueItemId: '3', ItemDisplayValue: 'In Review', ItemOrder: 3},
        {ValidValueItemId: '4', ItemDisplayValue: 'Approved', ItemOrder: 4}

    ];

    enumCustomForm_enumValidValueItem: enumValidValueItem[] = [];


    formControl_enumValidValueItem: enumValidValueItem[] = [
        {ValidValueItemId: '00000001-1000-0000-0000-000000000001', ItemDisplayValue: 'TextBox', ItemOrder: 1},
        {ValidValueItemId: '00000001-1000-0000-0000-000000000002', ItemDisplayValue: 'Heading', ItemOrder: 2},
        {ValidValueItemId: '00000001-1000-0000-0000-000000000003', ItemDisplayValue: 'Group Heading /w Summary', ItemOrder: 3},
        {ValidValueItemId: '00000001-1000-0000-0000-000000000004', ItemDisplayValue: 'Radio List', ItemOrder: 4},
        {ValidValueItemId: '00000001-1000-0000-0000-000000000005', ItemDisplayValue: 'CheckBox List', ItemOrder: 4},
        {ValidValueItemId: '00000001-1000-0000-0000-000000000006', ItemDisplayValue: 'Label', ItemOrder: 4}

    ];

    forms: cfgDForm[] = [
        {DFormId: '1', DFormName: 'Form 1', TDOCID: 1, enumFormCategoryID: '1', enumFormDataSourceID: '1', enumCustomFormID: '1', isToothRequired: true, isRequireSigniture: true, enumLayoutLevelID: '1'},
        {DFormId: '2', DFormName: 'Form 2', TDOCID: 2, enumFormCategoryID: '2', enumFormDataSourceID: '2', enumCustomFormID: '2', isToothRequired: false, isRequireSigniture: false, enumLayoutLevelID: '2'},
        {DFormId: '3', DFormName: 'Form 3', TDOCID: 3, enumFormCategoryID: '3', enumFormDataSourceID: '3', enumCustomFormID: '3', isToothRequired: true, isRequireSigniture: false, enumLayoutLevelID: '3'},
        {DFormId: '4', DFormName: 'Form 4', TDOCID: 4, enumFormCategoryID: '4', enumFormDataSourceID: '4', enumCustomFormID: '4', isToothRequired: false, isRequireSigniture: true, enumLayoutLevelID: '4'}
    ];


    paragraphs: cfgDFormParagraph[] = [
        {DFormParagraphId: '1' , ParagraphName: 'Paragraph 1', MaximumColumnCount: 8, MaximumRowCount: 3, ParagraphOrder: 1, isRepeting: false, numberOfCells: 24, colCountPerRow: [] , enumParagraphOrientationID: '',  enumItemLayoutID: '', PageBreakAfter: false},
        {DFormParagraphId: '2' , ParagraphName: 'Paragraph 2', MaximumColumnCount: 12, MaximumRowCount: 4, ParagraphOrder: 2, isRepeting: true, numberOfCells: 48, colCountPerRow: [] , enumParagraphOrientationID: '',  enumItemLayoutID: '', PageBreakAfter: false} ,
        {DFormParagraphId: '3' , ParagraphName: 'Paragraph 3', MaximumColumnCount: 6, MaximumRowCount: 5, ParagraphOrder: 3, isRepeting: false, numberOfCells: 30, colCountPerRow: [] , enumParagraphOrientationID: '',  enumItemLayoutID: '', PageBreakAfter: false},

    ];




    formItems: cfgDFormItem[] = [
        {DFormItemId: '1', DFormParagraphId: '1', DFormItemName: 'Lable 1', DFormMasterItemId: '1', ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 0, ParagraphRow: 0, ParagraphColumn: 0, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},
        {DFormItemId: '2', DFormParagraphId: '1', DFormItemName: 'Text 1', DFormMasterItemId: '2',  ParentDFormItemId: '2', HasChildren: false, enumFormControlID: '2', ItemOrder: 1, ParagraphRow: 0, ParagraphColumn: 1, ParagraphRowHeight: 2, ParagraphColumnWidth: 2, FormControlColumnSpan: 1, Label: 'Label 2', LabelWidth: 2, PostLabel: 'Post Label 2', ValidValueId: '2', BeforeDisplay_ItemActionId: '2', AfterUpdate_ItemActionId: '2', isRequired: false, DefaultValue: 'Default Value 2', isBreakAfterItem: false, CalculationID: '2', isNoteEnabled: false, isDocumentEnabled: false, enumLabelAligmentID: '2', enumPostLabelAligmentID: '2', isReadOnlyForPatient: false},

        {DFormItemId: '3', DFormParagraphId: '1', DFormItemName: 'Lable 2', DFormMasterItemId: '3', ParentDFormItemId: '3', HasChildren: false, enumFormControlID: '3', ItemOrder: 2, ParagraphRow: 1, ParagraphColumn: 0, ParagraphRowHeight: 3, ParagraphColumnWidth: 3, FormControlColumnSpan: 1, Label: 'Label 3', LabelWidth: 3, PostLabel: 'Post Label 3', ValidValueId: '3', BeforeDisplay_ItemActionId: '3', AfterUpdate_ItemActionId: '3', isRequired: true, DefaultValue: 'Default Value 3', isBreakAfterItem: true, CalculationID: '3', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '3', enumPostLabelAligmentID: '3', isReadOnlyForPatient: true},
        {DFormItemId: '4', DFormParagraphId: '1', DFormItemName: 'Text 2', DFormMasterItemId: '1',  ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 3, ParagraphRow: 1, ParagraphColumn: 1, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},

        {DFormItemId: '5', DFormParagraphId: '1', DFormItemName: 'Label 3', DFormMasterItemId: '2', ParentDFormItemId: '2', HasChildren: false, enumFormControlID: '2', ItemOrder: 4, ParagraphRow: 2, ParagraphColumn: 0, ParagraphRowHeight: 2, ParagraphColumnWidth: 2, FormControlColumnSpan: 1, Label: 'Label 2', LabelWidth: 2, PostLabel: 'Post Label 2', ValidValueId: '2', BeforeDisplay_ItemActionId: '2', AfterUpdate_ItemActionId: '2', isRequired: false, DefaultValue: 'Default Value 2', isBreakAfterItem: false, CalculationID: '2', isNoteEnabled: false, isDocumentEnabled: false, enumLabelAligmentID: '2', enumPostLabelAligmentID: '2', isReadOnlyForPatient: false},
        {DFormItemId: '6', DFormParagraphId: '1', DFormItemName: 'Text 3', DFormMasterItemId: '3',  ParentDFormItemId: '3', HasChildren: false, enumFormControlID: '3', ItemOrder: 5, ParagraphRow: 2, ParagraphColumn: 1, ParagraphRowHeight: 3, ParagraphColumnWidth: 3, FormControlColumnSpan: 1, Label: 'Label 3', LabelWidth: 3, PostLabel: 'Post Label 3', ValidValueId: '3', BeforeDisplay_ItemActionId: '3', AfterUpdate_ItemActionId: '3', isRequired: true, DefaultValue: 'Default Value 3', isBreakAfterItem: true, CalculationID: '3', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '3', enumPostLabelAligmentID: '3', isReadOnlyForPatient: true},


        {DFormItemId: '7', DFormParagraphId: '2', DFormItemName: 'Lable 21', DFormMasterItemId: '1', ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 0, ParagraphRow: 0, ParagraphColumn: 0, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},
        {DFormItemId: '8', DFormParagraphId: '2', DFormItemName: 'Text 21', DFormMasterItemId: '2',  ParentDFormItemId: '2', HasChildren: false, enumFormControlID: '2', ItemOrder: 1, ParagraphRow: 0, ParagraphColumn: 1, ParagraphRowHeight: 2, ParagraphColumnWidth: 2, FormControlColumnSpan: 1, Label: 'Label 2', LabelWidth: 2, PostLabel: 'Post Label 2', ValidValueId: '2', BeforeDisplay_ItemActionId: '2', AfterUpdate_ItemActionId: '2', isRequired: false, DefaultValue: 'Default Value 2', isBreakAfterItem: false, CalculationID: '2', isNoteEnabled: false, isDocumentEnabled: false, enumLabelAligmentID: '2', enumPostLabelAligmentID: '2', isReadOnlyForPatient: false},

        {DFormItemId: '9', DFormParagraphId: '2', DFormItemName: 'Lable 22', DFormMasterItemId: '3', ParentDFormItemId: '3', HasChildren: false, enumFormControlID: '3', ItemOrder: 2, ParagraphRow: 1, ParagraphColumn: 0, ParagraphRowHeight: 3, ParagraphColumnWidth: 3, FormControlColumnSpan: 1, Label: 'Label 3', LabelWidth: 3, PostLabel: 'Post Label 3', ValidValueId: '3', BeforeDisplay_ItemActionId: '3', AfterUpdate_ItemActionId: '3', isRequired: true, DefaultValue: 'Default Value 3', isBreakAfterItem: true, CalculationID: '3', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '3', enumPostLabelAligmentID: '3', isReadOnlyForPatient: true},
        {DFormItemId: '10', DFormParagraphId: '2', DFormItemName: 'Text 22', DFormMasterItemId: '1',  ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 3, ParagraphRow: 1, ParagraphColumn: 1, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},


        {DFormItemId: '11', DFormParagraphId: '3', DFormItemName: 'Lable 31', DFormMasterItemId: '1', ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 0, ParagraphRow: 0, ParagraphColumn: 0, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},
        {DFormItemId: '12', DFormParagraphId: '3', DFormItemName: 'Text 31', DFormMasterItemId: '2',  ParentDFormItemId: '2', HasChildren: false, enumFormControlID: '2', ItemOrder: 1, ParagraphRow: 0, ParagraphColumn: 1, ParagraphRowHeight: 2, ParagraphColumnWidth: 2, FormControlColumnSpan: 1, Label: 'Label 2', LabelWidth: 2, PostLabel: 'Post Label 2', ValidValueId: '2', BeforeDisplay_ItemActionId: '2', AfterUpdate_ItemActionId: '2', isRequired: false, DefaultValue: 'Default Value 2', isBreakAfterItem: false, CalculationID: '2', isNoteEnabled: false, isDocumentEnabled: false, enumLabelAligmentID: '2', enumPostLabelAligmentID: '2', isReadOnlyForPatient: false},

        {DFormItemId: '13', DFormParagraphId: '3', DFormItemName: 'Lable 32', DFormMasterItemId: '3', ParentDFormItemId: '3', HasChildren: false, enumFormControlID: '3', ItemOrder: 2, ParagraphRow: 1, ParagraphColumn: 0, ParagraphRowHeight: 3, ParagraphColumnWidth: 3, FormControlColumnSpan: 1, Label: 'Label 3', LabelWidth: 3, PostLabel: 'Post Label 3', ValidValueId: '3', BeforeDisplay_ItemActionId: '3', AfterUpdate_ItemActionId: '3', isRequired: true, DefaultValue: 'Default Value 3', isBreakAfterItem: true, CalculationID: '3', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '3', enumPostLabelAligmentID: '3', isReadOnlyForPatient: true},
        {DFormItemId: '14', DFormParagraphId: '3', DFormItemName: 'Text 32', DFormMasterItemId: '1',  ParentDFormItemId: '1', HasChildren: false, enumFormControlID: '1', ItemOrder: 3, ParagraphRow: 1, ParagraphColumn: 1, ParagraphRowHeight: 1, ParagraphColumnWidth: 1, FormControlColumnSpan: 1, Label: 'Label 1', LabelWidth: 1, PostLabel: 'Post Label 1', ValidValueId: '1', BeforeDisplay_ItemActionId: '1', AfterUpdate_ItemActionId: '1', isRequired: true, DefaultValue: 'Default Value 1', isBreakAfterItem: true, CalculationID: '1', isNoteEnabled: true, isDocumentEnabled: true, enumLabelAligmentID: '1', enumPostLabelAligmentID: '1', isReadOnlyForPatient: true},





    ];



    ngOnInit() {

        this.loadSupportingData( );



        this.selectedForm = this.forms[0];
        this.selectedVersion = { DFormVersionId: "", DFormId: "", Version: 1, enumDFormBuildStatusID: "", DFormBuildStatusBy: "", Revision:1 }

        // load paragraph data
        this.paragraphs.forEach(p => {

            const z = 0;

            const pi = this.formItems.filter(f => f.DFormParagraphId === p.DFormParagraphId).sort((a, b) => a.ParagraphRow < b.ParagraphRow ? -1 : 1);

            for (let i = 0; i < p.MaximumRowCount; i++) {

                const bb = pi.filter(f => f.ParagraphRow === i ).map(o => o.ParagraphColumn);

                if (!(bb === undefined || bb.length == 0))
                {
                    let maxValue = bb.reduce((a, b) => (a > b) ? a : b) + 1;

                    if (maxValue < p.MaximumColumnCount) {
                        maxValue = p.MaximumColumnCount;
                    }

                    p.colCountPerRow.push({rowIndex: i, cellCount: maxValue});
                }
                else {
                    p.colCountPerRow.push({rowIndex: i, cellCount: p.MaximumColumnCount});
                }
            }
        });
    }


    loadSupportingData()  {

        this.fbservice.getValidValues('enumFormCategory').subscribe(res => {
            this.formCategories_enumValidValueItem = res;
        });
        this.fbservice.getValidValues('enumFormDataSource').subscribe(res => {
            this.formDatSource_enumValidValueItem = res;
        });
        this.fbservice.getValidValues('enumCustomForm').subscribe(res => {
            this.enumCustomForm_enumValidValueItem = res;
        });
        this.fbservice.getValidValues('enumFormControl').subscribe(res => {
            this.formControl_enumValidValueItem = res;
        });
        this.fbservice.getValidValues('enumDFormBuildStatus').subscribe(res => {
            this.formStatus_enumValidValueItem = res;
        });

    }


    formOpenButtons = [
        {
            name: 'customButton',
            location: 'after',
            options: {
                text: '...',
                onClick: () => {
                    this.onOpenForm();
                },
            },
        }
    ];

    onOpenForm() {

        const dialogRef = this.dialog.open(FormBuilderOpenFormComponent, {
            width: '600px',
            height: '700px',

            data: {
                formList: this.forms

            }
        });

        dialogRef.afterClosed().subscribe(result => {
            // load all for selected form
            if (result !== 'X')  {
                // load form
                // let ret =  { selectedForm: this.selectedForm, selectedVersion: this.selectedVersion };

                this.selectedForm = result.selectedForm;
                this.selectedVersion = result.selectedVersion;


                // load this.paragraphs
                this.paragraphs = [];
                this.formItems = [];
                this.fbservice.getCfgDFormParagrahList(result.selectedVersion.DFormVersionId).subscribe(res => {

                    this.paragraphs = res;


                    this.fbservice.getCfgDFormItemList(result.selectedVersion.DFormVersionId).subscribe(res => {

                        this.formItems = res;

                        console.log('data', this.paragraphs,  this.formItems);

                    });


                });






            }


        });



    }





}
